var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTerm = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 63 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.5.75C14.526.75.75 14.526.75 31.5S14.526 62.25 31.5 62.25 62.25 48.474 62.25 31.5 48.474.75 31.5.75Zm0 1.5c16.163 0 29.25 13.087 29.25 29.25S47.663 60.75 31.5 60.75 2.25 47.663 2.25 31.5 15.337 2.25 31.5 2.25Zm0 6.75a.75.75 0 0 0-.75.75V31.5c0 .414.336.75.75.75h20.25a.75.75 0 0 0 0-1.5h-19.5v-21A.75.75 0 0 0 31.5 9Z",
  fill: "currentColor"
})));
export default SvgTerm;